/* eslint-disable no-mixed-operators */
export const getLastYear = () => new Date().getFullYear();
export const getCurrentYear = (generalInfo) => {
  let current_year = new Date().getFullYear();
  if (generalInfo && generalInfo.timespan) {
    if (current_year > generalInfo.timespan.max) {
      return generalInfo.timespan.max;
    } else if (current_year < generalInfo.timespan.min) {
      return generalInfo.timespan.min;
    } else {
      return current_year;
    }
  }
  return current_year;
};

export const formatNumber = (number) =>
  (number &&
    number.toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    })) ||
  "$ 0";

export const formatNumberNoFractionDigits = (number) =>
  (number &&
    number.toLocaleString(undefined, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    })) ||
  "0";

export const getDownloadCsvUrl = (url) =>
  `http://csvdownloader.iatistandard.org/csv/direct_from_registry/?search=&xml=${url}&download=true&id=true&format=full`;



// WEBPACK FOOTER //
// ./utils/index.js